import { useUpgradeDialog } from 'contexts/UpgradeDialogContext'

/**
 * useFeatureAccessGuard - Hook to block access if feature flag is false.
 *
 * @param {boolean} isFeatureEnabled - Whether the feature is allowed.
 * @returns {boolean} - true if access is blocked and upgrade dialog was shown.
 */
const useFeatureAccessGuard = () => {
  const { showUpgradeDialog } = useUpgradeDialog()

  return (isFeatureEnabled = false) => {
    if (!isFeatureEnabled) {
      showUpgradeDialog()

      return true
    }

    return false
  }
}

export default useFeatureAccessGuard
